module.exports = __webpack_public_path__ + "img/img_change_text02.0978dc65.png";